export {default} from './ReservationsListModel';
export * from './ReservationsListModel';



// WEBPACK FOOTER //
// ./src/models/ReservationsListModel/index.ts